import i18n from 'utils/i18n'
import type { AdminRequestsFilterName } from 'utils/filters/admin'
import type { TableFiltersConfig } from 'components/Common/Table/Layout/Page/_methods/types'
import {
  filterTypes,
  CHECKBOX_LIST,
  DATE_INTERVAL,
  RADIO_LIST,
  SCORE,
  INTERVAL,
  PRICE_INTERVAL,
  SWITCHER,
  NUMBER,
  offersFiltersTitle,
  offersFiltersName,
  offersFiltersKey,
  MULTISELECT_SWITCHER,
} from 'utils/consts'

export const getAdministrationRequestsFiltersCollection = () => [
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.stageFilter),
    filterName: offersFiltersName.stageFilter satisfies AdminRequestsFilterName,
    apiFilterName: offersFiltersKey().stageFilter,
  },
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(offersFiltersTitle.periodOfValidityFilter),
    filterName: offersFiltersName.periodOfValidityFilter,
    apiFilterName: offersFiltersKey().periodOfValidityFilter,
    maxDate: null,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(offersFiltersTitle.hasOffersFilter),
    filterName:
      offersFiltersName.hasOffersFilter satisfies AdminRequestsFilterName,
    apiFilterName: offersFiltersKey().hasOffersFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.wineCountryFilter),
    filterName:
      offersFiltersName.countryFilter satisfies AdminRequestsFilterName,
    apiFilterName: offersFiltersKey().countryFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.wineRegionEUFilter),
    filterName:
      offersFiltersName.wineRegionEUFilter satisfies AdminRequestsFilterName,
    apiFilterName: offersFiltersKey().wineRegionEUFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.nationalGITypeFilter),
    filterName:
      offersFiltersName.nationalGITypeFilter satisfies AdminRequestsFilterName,
    apiFilterName: offersFiltersKey().nationalGITypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.geoIndicationFilter),
    filterName:
      offersFiltersName.geoIndicationFilter satisfies AdminRequestsFilterName,
    apiFilterName: offersFiltersKey().geoIndicationFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.specialClassificationFilter),
    filterName:
      offersFiltersName.specialClassificationFilter satisfies AdminRequestsFilterName,
    apiFilterName: offersFiltersKey().specialClassificationFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.buyerCompanyUsernameFilter),
    filterName:
      offersFiltersName.buyerCompanyUsernameFilter satisfies AdminRequestsFilterName,
    apiFilterName: offersFiltersKey().buyerCompanyUsernameFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.buyerCompanyCategoryFilter),
    filterName:
      offersFiltersName.buyerCompanyCategoryFilter satisfies AdminRequestsFilterName,
    apiFilterName: offersFiltersKey().buyerCompanyCategoryFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.buyerCompanyCountryFilter),
    filterName:
      offersFiltersName.buyerCompanyCountryFilter satisfies AdminRequestsFilterName,
    apiFilterName: offersFiltersKey().buyerCompanyCountryFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.wineTypeFilter),
    filterName:
      offersFiltersName.wineTypeFilter satisfies AdminRequestsFilterName,
    apiFilterName: offersFiltersKey().wineTypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.wineColourFilter),
    filterName:
      offersFiltersName.wineColourFilter satisfies AdminRequestsFilterName,
    apiFilterName: offersFiltersKey().wineColourFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.sweetnessTypeFilter),
    filterName:
      offersFiltersName.sweetnessTypeFilter satisfies AdminRequestsFilterName,
    apiFilterName: offersFiltersKey().sweetnessTypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.vintageFilter),
    filterName:
      offersFiltersName.vintageFilter satisfies AdminRequestsFilterName,
    apiFilterName: offersFiltersKey().vintageFilter,
  },
  {
    type: filterTypes[MULTISELECT_SWITCHER],
    title: i18n.t(offersFiltersTitle.grapesFilter),
    filterName:
      offersFiltersName.grapesFilter satisfies AdminRequestsFilterName,
    apiFilterName: offersFiltersKey().grapesFilter,
    switchType: filterTypes[SWITCHER],
    switchFilterName: offersFiltersName.monocepageFilter,
    switchTitle: i18n.t(offersFiltersTitle.monocepageFilter),
    switchApiFilterName: offersFiltersKey().monocepageFilter,
  },
  {
    type: filterTypes[INTERVAL],
    title: i18n.t(offersFiltersTitle.alcoholLevelFilter),
    filterName:
      offersFiltersName.alcoholLevelFilter satisfies AdminRequestsFilterName,
    apiFilterName: offersFiltersKey().alcoholLevelFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.certificatesFilter),
    filterName:
      offersFiltersName.certificatesFilter satisfies AdminRequestsFilterName,
    apiFilterName: offersFiltersKey().certificatesFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.bottleSizeFilter),
    filterName:
      offersFiltersName.bottleSizeFilter satisfies AdminRequestsFilterName,
    apiFilterName: offersFiltersKey().bottleSizeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.packageTypeFilter),
    filterName:
      offersFiltersName.packageTypeFilter satisfies AdminRequestsFilterName,
    apiFilterName: offersFiltersKey().packageTypeFilter,
  },
  {
    type: filterTypes[PRICE_INTERVAL],
    title: i18n.t(offersFiltersTitle.priceFilter),
    filterName: offersFiltersName.priceFilter satisfies AdminRequestsFilterName,
    apiFilterName: offersFiltersKey().priceFilter,
  },
  {
    type: filterTypes[NUMBER],
    title: i18n.t(offersFiltersTitle.minimalBatchFilter),
    filterName: offersFiltersName.minimalBatchFilter,
    apiFilterName: offersFiltersKey().minimalBatchFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(offersFiltersTitle.deliveryTermsFilter),
    filterName:
      offersFiltersName.deliveryTermsFilter satisfies AdminRequestsFilterName,
    apiFilterName: offersFiltersKey().deliveryTermsFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(offersFiltersTitle.countryOfShipmentFilter),
    filterName:
      offersFiltersName.countryOfShipmentFilter satisfies AdminRequestsFilterName,
    apiFilterName: offersFiltersKey().countryOfShipmentFilter,
  },
  {
    type: filterTypes[SCORE],
    title: i18n.t(offersFiltersTitle.wwlRatingFilter),
    filterName:
      offersFiltersName.wwlRatingFilter satisfies AdminRequestsFilterName,
    apiFilterName: offersFiltersKey().wwlRatingFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.producerFilter),
    filterName:
      offersFiltersName.producerFilter satisfies AdminRequestsFilterName,
    apiFilterName: offersFiltersKey().producerFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.brandFilter),
    filterName: offersFiltersName.brandFilter satisfies AdminRequestsFilterName,
    apiFilterName: offersFiltersKey().brandFilter,
  },
  {
    type: filterTypes[SWITCHER],
    title: i18n.t(offersFiltersTitle.exclusiveOffersFilter),
    filterName: offersFiltersName.exclusiveOffersFilter,
    apiFilterName: offersFiltersKey().exclusiveOffersFilter,
  },
  {
    type: filterTypes[SWITCHER],
    title: i18n.t(offersFiltersTitle.onlyFromProducerFilter),
    filterName: offersFiltersName.onlyFromProducerFilter,
    apiFilterName: offersFiltersKey().onlyFromProducerFilter,
  },
  {
    type: filterTypes[SWITCHER],
    title: i18n.t(offersFiltersTitle.forCompanyOnlyFilter),
    filterName: offersFiltersName.forCompanyOnlyFilter,
    apiFilterName: offersFiltersKey().forCompanyOnlyFilter,
  },
]

export const adminRequestsFiltersConfig: TableFiltersConfig = {
  getFiltersCollection: getAdministrationRequestsFiltersCollection,
  pathToStore: ['offers'],
  filtersDataPath: ['admin', 'wineOfferRequests', 'wineOfferRequestsFilters'],
  showResultsTextKey: 'filters.button.showRequests',
}
